module.exports = __webpack_public_path__ + "static/media/credit-card.707ec04e.svg";